export function viewCommon(field, data, viewFilter) {
  let newData = [...data];

  newData = newData.filter((item) => viewFilter.includes(item[field]));

  return [...newData];
}
